import { UnsupportedBrowser } from 'shared-components/lib/components/pages/unsupported-browser';
import { enrolyTheme } from 'shared-components/lib/theme';
import { FetchErrorBoundary } from 'shared-components/lib/components/pages/errors/FetchErrorBoundary';
import { Authentication } from 'shared-components/lib/components/pages/authentication';
// import { FetchErrorBoundary, Authentication } from 'shared-components';
// import Tawk from './utilities/tawk';
import { Routes, Route, useLocation, useSearchParams } from 'react-router-dom';
import { getGlobalConfig } from './utilities/globalConfig';
import { ChakraProvider } from '@chakra-ui/react';
import errorService from './services/errorService';
import { ErrorBoundary } from './ErrorBoundary';
import StatusUpdate from './components/pages/statusUpdate';
import { ContextWrapper } from './ContextWrapper';
import UnsubscribePage from './components/pages/unsubscribe';
import './global.css';

const NON_AUTH_PAGES = ['/unsubscribe', '/visaStatusUpdate', '/confirmArrival', '/noChangeArrival'];

function App() {
  const globalConfig = getGlobalConfig();

  const location = useLocation();

  const getStudentNonAuthPages = () => (
    <Routes>
      <Route path="/unsubscribe" element={<UnsubscribePage />} />
      <Route path="/visaStatusUpdate" element={<StatusUpdate />} />
      <Route path="/confirmArrival" element={<StatusUpdate />} />
      <Route path="/noChangeArrival" element={<StatusUpdate />} />
    </Routes>
  );
  const [searchParams] = useSearchParams();
  const code = searchParams.get('hash');

  return (
    <FetchErrorBoundary errorService={errorService}>
      <ErrorBoundary>
        <ChakraProvider theme={enrolyTheme}>
          <UnsupportedBrowser>
            <>
              {NON_AUTH_PAGES.includes(location.pathname) ? (
                getStudentNonAuthPages()
              ) : (
                <Authentication
                  assetsUrl={globalConfig.assetsUrl}
                  appClient={globalConfig.studentAppClient}
                  userPoolId={globalConfig.userpool}
                  mfaEnabled={globalConfig.studentsMFAEnabled}
                  uniCode={globalConfig.uni}
                  apiUrl={globalConfig.apiUrl}
                  {...(code ? { code } : {})}
                  isStudentApp={true}
                  cognitoDomain={globalConfig.cognitoDomain}
                  cognitoProviderName={globalConfig.cognitoProviderName}
                  redirectUrl={globalConfig.redirectUrl}
                >
                  <ContextWrapper />
                </Authentication>
              )}
            </>
          </UnsupportedBrowser>
        </ChakraProvider>
      </ErrorBoundary>
    </FetchErrorBoundary>
  );
}

export { App };

/* {window.location.hostname !== 'localhost' ? <Tawk hideTawk={true} /> : null} */
